import Vue from "vue";
import axios from "axios";
import qs from "qs";
import Code from "@/utils/code";
import "@/utils/global.js";
import { serialize } from "@/utils/util";

// create an axios instance
console.log(global.HOST);
const service = axios.create({
  baseURL: global.HOST, // api的base_url
  timeout: 20000, // request timeout
  withCredentials: false, // 使前台能够保存cookie
  responseType: "json"
});

// service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 请求时的拦截
service.interceptors.request.use(
  function(config) {
    // 发送请求之前做一些处理
    // const lndb = Vue.lndb.init('token')
    let token = global.apis.getToken();

    if(!config.params["notoken"]){
      if (token) {
        // if(config.params) config.params['access_token'] = token
        // else config.params= {access_token: token}
        config.headers.Authorization = "Bearer " + token;
      } else
        config.headers.Authorization =
          "Basic SmN1TWxaOEpETUE0WEdwYzpVblA3SGdJc0l2WHdadFk0ZVJ2RVNBZTlubW9peDZYdg==";
    }

    // 英文版请求
    if (config.params["lang"] == "En")
      config.headers["Accept-Language"] = "en-US";

    // config.headers['Content-Type'] = "application/x-www-form-urlencoded";
    // if(config.type == 'formData' || config.method != 'post'){
    //   return config
    // }
    // config.data = qs.stringify(config.data)
    // headers中配置serialize为true开启序列化
    // if (config.method === 'post' && config.url != "auth/mobile/token/social") {
    //   config.data = serialize(config.data)
    //   delete config.data.serialize
    // }

    return config;
  },
  function(error) {
    // 当请求异常时做一些处理
    return error.response;
  }
);

// 响应时拦截
service.interceptors.response.use(
  function(response) {
    // 返回响应时做一些处理
    // console.log(response.data.code)

    return response;
  },
  function(error) {
    // 当响应异常时做一些处理
    return error.response;
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js